<template>
  <div  class="block">
      <div>
           <el-date-picker
                v-model="value1"
                type="daterange"
                :picker-options="pickerOptions"
                >
            </el-date-picker>
            <el-select v-model="value" placeholder="请选择">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="data_source" placeholder="请选择">
                <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-input placeholder="请在此输入正确的账号" v-model="id" class="input-with-select">    
            </el-input>
            <el-input placeholder="请在此输入正确的账号" v-model="type" class="input-with-select">    
            </el-input>
            <el-button @click="select">搜索</el-button>
      </div>
      <div class="tab">
           <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="0"
                    label="ID">
                </el-table-column>
                <el-table-column
                    prop="1"
                    label="时间"
                    >
                </el-table-column>
                <el-table-column
                    prop="2"
                    label="类型"
                >
                </el-table-column>
                <el-table-column
                    prop="3"
                    label="持续时间/s">
                </el-table-column>
                <el-table-column
                    prop="4"
                    label="速率">
                </el-table-column>
                <el-table-column
                    prop="5"
                    label="输注量">
                </el-table-column>
                <el-table-column
                    prop="6"
                    label="参数1">
                </el-table-column>
                <el-table-column
                    prop="7"
                    label="参数2">
                </el-table-column>
                <el-table-column
                    prop="8"
                    label="删除标志">
                </el-table-column>
            </el-table>
            <el-pagination class="fy"
                layout="prev, pager, next, jumper"
                @current-change="current_change"
                :total="total"
                background
                :current-page.sync ="filterPage"
                >
            </el-pagination>
      </div>
  </div>
</template>

<script>
import {format} from '../method'
export default {
    data() {
        return {
            value1: [new Date(new Date().toLocaleDateString()), new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() +24 * 60 * 60 * 1000 -1))],
            pickerOptions:{
                onPick: ({ maxDate, minDate }) => {
                // 把选择的第一个日期赋值给一个变量。
                this.choiceDate = minDate.getTime();
                // 如何你选择了两个日期了，就把那个变量置空
                if (maxDate) this.choiceDate = "";
                },
                disabledDate: time => {
                    // 如何选择了一个日期
                    if (this.choiceDate) {
                        // 7天的时间戳
                        const one = 7 * 24 * 3600 * 1000;
                        // 当前日期 - one = 7天之前
                        const minTime = this.choiceDate - one;
                        // 当前日期 + one = 7天之后
                        const maxTime = this.choiceDate + one;
                        return (
                            time.getTime() < minTime ||
                            time.getTime() > maxTime ||
                            // 限制不能选择今天及以后
                            time.getTime() - 2 * 24 * 3600 * 1000 > Date.now()
                        );
                    } else {
                    // 如果没有选择日期，就要限制不能选择今天及以后
                    return time.getTime() - 2 * 24 * 3600 * 1000 > Date.now();
                    }
                    }
            },
            value:'',
            options:[{
                value: 'N',
                label: 'N'
            }, {
                value: 'Y',
                label: 'Y'
            }],
             options1:[{
                value: 'daopapp',
                label: 'daopapp'
            }, {
                value: 'daoppdf',
                label: 'daoppdf'
            }],
            tableData:[],
            pagesize: 10,
            currentPage: 1,
            filterPage: 1,
            total:0,
            id:'',
            type:'',
            data_source:'daopapp'
        }
    },
    methods:{
        search (val) {
            let that =this
            this.$http.post('/api/v2.1/admin/devdebug/data/get_record',val).then(res => {
                if(res.status ===200){
                    if(res.data.error===0){
                        console.log(res.data.data)
                     this.tableData =res.data.data
                    for(let i =0;i< that.tableData.length;i++){
                     that.tableData[i][1] =format(that.tableData[i][1])
                    }
                    that.total =res.data.data.length
                    } 
                }else{

                }
            })
        },
        current_change: function (currentPage) {
            this.currentPage = currentPage
        },
        select() {
            let data =this.$route.query
            let st,et =0
            if(this.value1.length>1){
                st =this.value1[0].getTime()/1000
                et =this.value1[1].getTime()/1000
            }
            let val ={
                username:data.username,
                et:et,
                st:st,
                data_source:this.data_source,
                flag:data.flag
            }
            let that =this
            this.$http.post('/api/v2.1/admin/devdebug/data/get_record',val).then(res => {
                if(res.status ===200){
                    if(res.data.error===0){
                        let data =res.data.data
                        that.tableData =[]
                        for(let i =0;i< data.length;i++){
                            data[i][1] =format(data[i][1])
                        }
                        for(let j=0;j<data.length;j++){
                            if((data[j][0].search(that.id)!=-1||that.id=='')&&(data[j][2].search(that.type)!=-1||that.type=='')&&(data[j][8].search(that.value)!=-1||that.value=='')){
                                that.tableData.push(data[j])
                            }
                        }
                        that.total =that.tableData.length
                    } 
                }else{

                }
            })
        }
    },
    mounted(){
        let data =this.$route.query
        let st,et =0
        console.log(this.value1)
        if(this.value1.length>1){
            st =this.value1[0].getTime()/1000
            et =this.value1[1].getTime()/1000
        }
        
        let val ={
            username:data.username,
            et:et,
            st:st,
            data_source:'daopapp',
            flag:data.flag
        }
        this.search(val)
    }
}
</script>

<style scoped>
.block{
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;
}
 .tab {
     width:90%;
     margin-top: 20px;
 }
 .fy {
      margin-top: 20px;
      width: 100%;
  }
 .input-with-select {
     width: 200px;
     margin-left: 3px;
  }
</style>


// WEBPACK FOOTER //
// BasicQuantity.vue?8ff6a0aa